import { BlockInstanceType } from 'application-types';

function getChildBlocks(
  children: BlockInstanceType['children'] | undefined
): BlockInstanceType[] {
  return Array.isArray(children) ? children : [];
}

export function getLayoutFieldIds(
  block: BlockInstanceType | undefined
): Set<string> {
  const fieldIds = new Set<string>();

  function walk(current: BlockInstanceType | undefined) {
    if (!current) {
      return;
    }

    if (current.for) {
      fieldIds.add(current.for);
    }

    if (current.properties?.propertyKey) {
      fieldIds.add(current.properties.propertyKey);
    }

    getChildBlocks(current.children).forEach(walk);
    getChildBlocks(current.properties?.children).forEach(walk);
  }

  walk(block);

  return fieldIds;
}
